import { strings } from "../strings";

export function LoadingScreen() {
  return (
    <div role="status" aria-live="polite" className="eg-loading-screen">
      {strings.loading}
    </div>
  );
}
